import { useId } from "react";
import { textureSrc } from "@/lib/catalog";

// Silhueta provisória da peça preenchida com o tecido escolhido. Substituída por fotografias reais.
const scallop = (cx, cy, R, n, r) => {
  const pts = Array.from({ length: n }, (_, i) => {
    const a = (i / n) * Math.PI * 2 - Math.PI / 2;
    return [cx + R * Math.cos(a), cy + R * Math.sin(a)];
  });
  return `M${pts[0].join(" ")} ` + pts.map((_, i) => `A${r} ${r} 0 0 1 ${pts[(i + 1) % n].join(" ")}`).join(" ") + " Z";
};

const NECK = (
  <>
    <circle cx="100" cy="66" r="19" fill="black" />
    <rect x="96.5" y="10" width="7" height="50" fill="black" />
  </>
);

const SHAPES = {
  generica: { path: "M36 52 Q36 40 48 40 H152 Q164 40 164 52 V148 Q164 160 152 160 H48 Q36 160 36 148 Z" },
  flor: { path: scallop(100, 108, 74, 12, 21), neck: true },
  redondo: { path: "M22 108 a78 78 0 1 0 156 0 a78 78 0 1 0 -156 0 Z", neck: true },
  bolsa: { path: "M56 74 Q56 58 72 58 H128 Q144 58 144 74 V150 Q144 170 124 170 H76 Q56 170 56 150 Z", extra: "M86 58 Q100 30 114 58" },
  carteira: { path: "M28 62 Q28 50 40 50 H160 Q172 50 172 62 V148 Q172 160 160 160 H40 Q28 160 28 148 Z", extra: "M30 66 L100 108 L170 66" },
  tapa: { path: "M40 62 H160 Q168 100 172 122 Q160 150 128 152 Q110 128 100 128 Q90 128 72 152 Q40 150 28 122 Q32 100 40 62 Z", extra: "M42 76 H158" },
};

export const ProductVisual = ({ shape = "flor", texture = "linho", className = "", size = 800 }) => {
  const id = useId().replace(/[^a-zA-Z0-9]/g, "");
  const s = SHAPES[shape] ?? SHAPES.flor;
  return (
    <svg viewBox="0 0 200 200" className={className} role="img" aria-label="Silhueta provisória da peça">
      <defs>
        <mask id={`m${id}`}>
          <path d={s.path} fill="white" />
          {s.neck && NECK}
        </mask>
      </defs>
      <g style={{ filter: "drop-shadow(0 10px 14px rgba(64,55,49,0.14))" }}>
        <image href={textureSrc(texture, size)} width="200" height="200" preserveAspectRatio="xMidYMid slice" mask={`url(#m${id})`} />
      </g>
      <path
        d={s.path}
        fill="none"
        stroke="rgb(250 247 242)"
        strokeOpacity="0.85"
        strokeWidth="1.1"
        strokeDasharray="3 3"
        transform="translate(100 108) scale(0.9) translate(-100 -108)"
        mask={`url(#m${id})`}
      />
      {s.extra && <path d={s.extra} fill="none" stroke="rgb(117 67 75)" strokeOpacity="0.55" strokeWidth="1.4" strokeDasharray="4 3" />}
    </svg>
  );
};
